import { useRouter } from 'next/router';
import {
  applyTruncationForAllScreen,
  findValueByKey,
  getImage,
  getTarget,
  isItUndefined,
  isLinkAbsolute,
  removeNbsp,
  stripHtml,
} from '../../util/DataUtil';
import { useEffect, useState } from 'react';
import Image from 'next/image';

const ResourcePopular = ({ posts, title, onChipClick, width }) => {
  if (posts.length === 0) {
    return '';
  }

  const router = useRouter();
  const [titles, setTitles] = useState([]);

  const truncate = () => {
    const titles = posts.map((item) => {
      const templateTitle = isItUndefined(
        item?.field_template_blocks?.template_title_block_type
          ?.field_template_title
      );
      const heroFormattedTitle = isItUndefined(
        item?.field_template_blocks?.hero_graphic_block_type
          ?.field_formatted_title
      );

      if (!templateTitle && !heroFormattedTitle) {
        return '';
      }

      return [
        applyTruncationForAllScreen(
          templateTitle,
          63,
          43,
          45,
          18,
          32,
          37,
          width
        ),
        applyTruncationForAllScreen(
          removeNbsp(stripHtml(heroFormattedTitle)),
          63,
          43,
          45,
          18,
          32,
          37,
          width
        ),
      ];
    });

    setTitles(titles);
  };

  useEffect(() => {
    truncate();
  }, [posts]);

  const size = useWindowSize();

  function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });

    useEffect(() => {
      // only execute all the code below in client side
      if (typeof window !== 'undefined') {
        // Handler to call on window resize
        function handleResize() {
          // Set window width/height to state
          setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
          });
        }

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Call handler right away so state gets updated with initial window size
        handleResize();

        // Remove event listener on cleanup
        return () => window.removeEventListener('resize', handleResize);
      }
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
  }

  const renderPosts = () => {
    return posts.map((item, index) => {
      return (
        <div key={'popular-key-' + index} className={'item'}>
          <div className={'img-container'}>
            {getImage(
              item?.field_template_blocks?.template_banner_block_type
                ?.field_template_banner_bynder?.webimage,
              item?.field_template_blocks?.template_banner_block_type
                ?.field_web_small_image?.webimage,
              item?.field_template_blocks?.hero_graphic_block_type?.webimage
            ) ? (
              <Image
                objectFit="center"
                layout="fill"
                alt="resource-popular"
                src={getImage(
                  item.field_template_blocks.template_banner_block_type
                    ?.field_template_banner_bynder.webimage,
                  item.field_template_blocks.template_banner_block_type
                    ?.field_web_small_image.webimage,
                  item?.field_template_blocks?.hero_graphic_block_type?.webimage
                )}
              />
            ) : (
              <Image
                layout="fill"
                alt="placeholder"
                src={'/images/placeholder.png'}
              />
            )}
          </div>
          <span className={'category'}>
            {item?.field_content_type_templat[0]?.name}
            {item?.field_time_to_read[0]?.value ? ',' : ''}{' '}
            {item?.field_time_to_read[0]?.value}
          </span>
          <a
            className={'title span-resource-popular-link'}
            href={item['url-alias'].length !== 0 ? item['url-alias'] : '/'}
            target={getTarget(item['url-alias'])}
          >
            {titles[index]}
          </a>
          {item?.field_template_secondary_categor && (
            <span
              className={'second-category category-hover'}
              onClick={(event) =>
                onChipClick(event, [
                  { name: item?.field_template_category[0]?.name },
                ])
              }
            >
              {item?.field_template_category[0]?.name}
            </span>
          )}
          <hr />
        </div>
      );
    });
  };

  return (
    <div className={'resource-popular'}>
      <div className={'inner-container'}>
        <span className={'page-sub'}>{title}</span>
        <hr />
        <div className={'posts'}>{renderPosts()}</div>
      </div>
    </div>
  );
};

export default ResourcePopular;
